<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>
    <template #content>
      <article class="blog-content">
        <section class="intro">
          <p>
            If you're looking to delete your Travvir account, please note that
            this feature is currently only available on the Android app. Follow
            the steps below to permanently delete your account.
          </p>
        </section>

        <section>
          <h2>Step-by-Step Guide</h2>
          <ol>
            <li>Open the Travvir app on your Android device.</li>
            <li>
              Tap the hamburger menu icon (three horizontal lines) in the
              top-left corner to open the navigation drawer.
            </li>
          </ol>

          <figure class="content-image">
            <NuxtImg
              :src="cdnUrl + '/static/images/delete_account_1.jpg'"
              alt="Navigation drawer with Delete Account option"
            />
            <figcaption>
              Figure 1: Navigation drawer showing the Delete Account option
            </figcaption>
          </figure>

          <ol start="3">
            <li>Scroll down and tap on "Delete Account" from the menu.</li>
            <li>
              A confirmation dialog will appear. Tap
              <strong>"Delete"</strong> to confirm and permanently delete your
              account.
            </li>
          </ol>

          <figure class="content-image">
            <NuxtImg
              :src="cdnUrl + '/static/images/delete_account_2.jpg'"
              alt="Confirmation dialog for account deletion"
            />
            <figcaption>
              Figure 2: Confirmation dialog to delete the account
            </figcaption>
          </figure>
        </section>

        <section>
          <div class="warning-box">
            <h4>⚠️ Important</h4>
            <p>
              Once you initiate account deletion, your account and all related
              data will be deleted after 14 days. If you change your mind, you
              can log back in within this period to cancel the deletion process.
            </p>
          </div>
        </section>
      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";

const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;

const postData = blogPostsData.find(
  (post) => post.slug === "how-to-delete-account",
);

useBlogSeo({
  title: "How to Delete Your Account on Travvir",
  description:
    "Step-by-step guide to permanently deleting your Travvir account on Android. Learn about the 14-day grace period and what happens to your data.",
  keywords:
    "delete Travvir account, remove account, Travvir Android, account deletion, permanent delete",
  slug: "how-to-delete-account",
  image: postData?.image,
  postData,
  lang: "en",
});

</script>
